// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1osq{width:100%}\n._4t3i815d{height:calc(100vh - 13pc)}", ""]);
// Exports
module.exports = exports;
